import { render, staticRenderFns } from "./DirectDepartment.vue?vue&type=template&id=44aa9a44&scoped=true&"
import script from "./DirectDepartment.vue?vue&type=script&lang=js&"
export * from "./DirectDepartment.vue?vue&type=script&lang=js&"
import style0 from "./DirectDepartment.vue?vue&type=style&index=0&id=44aa9a44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44aa9a44",
  null
  
)

export default component.exports